import FadeIn from "../components/FadeIn";
import SEO from "../components/SEO";
import { seoByPath } from "../lib/seo";

const CookiePolicy = () => {
    return (
        <main data-testid="page-cookie" className="bg-white text-[#111111]">
            <SEO {...seoByPath["/cookie-politik"]} path="/cookie-politik" />
            <section className="pt-40 md:pt-56 pb-12 md:pb-20">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6">
                    <FadeIn className="col-span-12 md:col-span-4">
                        <div className="text-[11px] tracking-luxury uppercase text-[#888]">
                            Information
                        </div>
                    </FadeIn>
                    <FadeIn delay={0.1} className="col-span-12 md:col-span-8">
                        <h1 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight">
                            Cookie-politik
                        </h1>
                    </FadeIn>
                </div>
            </section>

            <section className="pb-32 md:pb-48 border-t border-[#EAE8E4] pt-16 md:pt-24">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6">
                    <FadeIn className="col-span-12 md:col-span-8 md:col-start-3 space-y-10 text-base md:text-lg text-[#222] leading-relaxed md:leading-relaxed">
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                1. Introduktion
                            </h2>
                            <p>
                                Denne cookiepolitik forklarer, hvordan MM Byggeri & Rådgivning
                                (&ldquo;vi&rdquo;, &ldquo;vores&rdquo;, &ldquo;os&rdquo;) bruger
                                cookies og lignende teknologier på vores hjemmeside. Ved at bruge
                                vores hjemmeside accepterer du brugen af cookies som beskrevet i
                                denne politik.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                2. Hvad er cookies?
                            </h2>
                            <p>
                                Cookies er små tekstfiler, der gemmes på din enhed (computer,
                                tablet eller mobil), når du besøger en hjemmeside. Cookies
                                hjælper os med at forbedre din oplevelse på vores hjemmeside ved
                                at huske dine præferencer og tidligere handlinger.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                3. Typer af cookies vi bruger
                            </h2>
                            <ul className="space-y-3 list-none pl-0">
                                <li>
                                    <strong className="font-medium">Nødvendige cookies:</strong>{" "}
                                    essentielle for at muliggøre grundlæggende funktioner på
                                    hjemmesiden, såsom navigering og adgang til sikre områder.
                                </li>
                                <li>
                                    <strong className="font-medium">Præference cookies:</strong>{" "}
                                    husker oplysninger, der ændrer den måde, hjemmesiden ser ud
                                    eller opfører sig på.
                                </li>
                                <li>
                                    <strong className="font-medium">Statistik cookies:</strong>{" "}
                                    hjælper os med at forstå, hvordan besøgende interagerer med
                                    hjemmesiden ved at indsamle og rapportere oplysninger anonymt.
                                </li>
                                <li>
                                    <strong className="font-medium">Marketing cookies:</strong>{" "}
                                    bruges til at spore besøgende på tværs af hjemmesider for at
                                    vise relevante annoncer.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                4. Sådan bruger vi cookies
                            </h2>
                            <ul className="space-y-2 list-disc pl-6">
                                <li>Forbedre funktionaliteten og ydeevnen af vores hjemmeside.</li>
                                <li>Analysere trafik og brugeradfærd på vores hjemmeside.</li>
                                <li>Tilpasse din oplevelse ved at huske dine præferencer.</li>
                                <li>Levere relevant indhold og annoncer til dig.</li>
                            </ul>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                5. Administration af cookies
                            </h2>
                            <p>
                                De fleste webbrowsere giver dig mulighed for at kontrollere
                                cookies gennem browserindstillingerne. Du kan indstille din
                                browser til at blokere eller slette cookies, men vær opmærksom
                                på, at dette kan påvirke funktionaliteten af vores hjemmeside.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                6. Ændringer i cookie-politik
                            </h2>
                            <p>
                                Vi forbeholder os retten til at ændre denne cookiepolitik til
                                enhver tid. Eventuelle ændringer vil blive offentliggjort på
                                denne side, og vi opfordrer dig til regelmæssigt at gennemgå
                                politikken for at være opdateret med, hvordan vi bruger cookies.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                7. Kontakt
                            </h2>
                            <p>
                                Hvis du har spørgsmål om vores brug af cookies, er du velkommen
                                til at kontakte os på{" "}
                                <a
                                    href="mailto:mm@mmbr.dk"
                                    className="link-underline"
                                >
                                    mm@mmbr.dk
                                </a>
                                .
                            </p>
                        </div>
                    </FadeIn>
                </div>
            </section>
        </main>
    );
};

export default CookiePolicy;
